import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-montserrat absolute bottom-0 left-0 mb-2 text-center w-full" }
const _hoisted_2 = { class: "text-12px xxl:text-14px text-gray-lp-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("span", _hoisted_2, "@ " + _toDisplayString(new Date().getFullYear()) + " All Rights Reserved - Lion Parcel", 1)
  ]))
}